module.exports = __webpack_public_path__ + "img/4-1_07.94310a42.jpg";